import { lazy, Suspense } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { X } from "lucide-react";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import {
  SchemaCanvasControlsProvider,
  SchemaCanvasMenu,
  SchemaCanvasSearch,
  SchemaNewCollectionButton,
} from "@/components/collections/schema-canvas/schema-canvas-controls";
import { SchemaModeSwitch } from "@/components/collections/schema-canvas/schema-mode-switch";

// React Flow solo se descarga al abrir el esquema.
const SchemaCanvas = lazy(
  () => import("@/components/collections/schema-canvas/schema-canvas"),
);

export const Route = createFileRoute("/_authenticated/settings/_layout/collections/schema")(
  {
    component: SchemaPage,
  },
);

/** Esquema de las colecciones y tablas del sistema en un lienzo de nodos. */
function SchemaPage() {
  return (
    <SchemaCanvasControlsProvider>
      <RouteGuardPermissions
        permissions={[{ module: "custom_fields", actions: ["read"] }]}
      >
        <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-hidden">
          <div className="flex shrink-0 flex-wrap items-center gap-2">
            {/* Búsqueda a la izquierda; menú del lienzo, modo y cerrar a la derecha. */}
            <h1 className="sr-only">Esquema</h1>
            <SchemaCanvasSearch />
            <div className="ml-auto flex flex-wrap items-center gap-2">
              <SchemaCanvasMenu />
              <SchemaModeSwitch />
              <SchemaNewCollectionButton />
              {/* Separador sutil antes de Cerrar. */}
              <span aria-hidden className="mx-0.5 h-5 w-px bg-border" />
              <Button
                type="button"
                variant="outline"
                size="icon-sm"
                asChild
                title="Cerrar"
                aria-label="Cerrar el esquema"
              >
                <Link to="/settings/collections">
                  <X className="h-3.5 w-3.5" />
                </Link>
              </Button>
            </div>
          </div>
          <div className="flex min-h-0 flex-1">
            <Suspense
              fallback={
                <Skeleton className="h-full min-h-[24rem] w-full rounded-md" />
              }
            >
              <SchemaCanvas />
            </Suspense>
          </div>
        </div>
      </RouteGuardPermissions>
    </SchemaCanvasControlsProvider>
  );
}
